// Angular Core
import { Component, OnInit, Input, Output, EventEmitter, HostListener, ViewChild } from "@angular/core";
import { Renderer2, ElementRef } from "@angular/core";
import { DatePipe, NgFor, NgIf, NgClass } from "@angular/common";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { ImageCompressService, ResizeOptions } from "@artiomsu/ng2-image-compress";
// PDF Excel
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// Services
import { QueryLayersService } from "../services/query-layers.service";
import { AssetAttributesService } from "../services/asset-attributes.service";
import { AuthenticationService } from "src/app/services/authentication.service";
import { GenericLayerService } from "../services/generic-layer.service";
import { AssetDetailService } from "../services/asset-detail.service";
// Added by Abhilash Jira Id:-39 on 9/28/2021
import { EsriMapComponent } from "../esri-map/esri-map.component";
import { environment } from "src/environments/environment";
// User and Data
import { Globals } from "../shared/globals";
import { IUser } from "../interface/user";
// Swal alerts
import Swal from "sweetalert2";
// Events
import { EventEmittersService } from "../services/event-emitters.service";
import { faWindowClose } from "@fortawesome/free-regular-svg-icons";
import { faDownload, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
// ag-grid customToolTip
import { CustomTooltip } from "./customTooltip.component"; // Added by Abhilash Jira Id:-40 on 9/28/2021
import { MatSelect } from "@angular/material/select";
import { getMimeType } from "src/app/shared/utils";
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { FormsModule } from "@angular/forms";
import { AgGridAngular } from "ag-grid-angular";
import { MatTabsModule, MatTabChangeEvent } from "@angular/material/tabs";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { ILayerSelections } from "../interface/selectedSet";
import { ILayer } from "../interface/layer";

// tests: 
//        when first open the asset table, the feature asset currently active in asset viewer should determine which tab is activated and row is highlighted. note: as of now, if child asset is active when asset table is opened, the parent asset is shown in the table
//        in asset table 
//            click new tab - should highlight the first row, and update map and AV to display that asset
//            click row, asset viewer and map location should update accordingly
//            click child asset row, asset viewer and map location should update if needed, and child card should be highlighted on asset viewer
//            with child tab active, click the parent card in asset viewer - table should switch to the parent tab and highlight the appropriate parent row
//        asset viewer
//            step through assets, asset table should highlight row corresponding to active asset
//            change layer, table should switch tab and highlight the row corresponding to the active asset
//            click to activate child asset card, asset table should switch tab, if necessary, and highlight the corresponding parent row
//        map
//            click asset in currently active class, asset table should highlight the corresponding row
//            click asset in different class, asset table should switch tab and highlight the corresponding row
//        ?? tbd - when step through Supports on Asset Viewer while Sign/Light tab is open in asset table? ? attempt to select/highlight card of first child asset? or nothig??

pdfMake.vfs = pdfFonts.pdfMake.vfs;
@Component({
    selector: "sms-asset-table",
    templateUrl: "./asset-table.component.html",
    styleUrls: ["../asset-viewer/asset-viewer.component.scss"],
    standalone: true,
    imports: [ConfigurableHeaderComponent, MatTabsModule, NgFor, NgIf, AgGridAngular, NgClass, FormsModule, MatButtonToggleModule, PdfViewerModule, DatePipe, TranslateModule, CustomTranslatePipe]
})
export class AssetTableComponent implements OnInit {
  @ViewChild("mySelect") mySelect: MatSelect;
  selected: string;

  OpenSel() {
    this.mySelect.open();
  }
  // @Input() rowdataobj: any;
  @Input() map;
  @Input() RelationshipQuery;
  @Input() FeatureLayer;
  @Input() FeatureTable;
  rowStyle = { padding: "8px 0" };
  @Output() selectedRow = new EventEmitter();

  currentUser: IUser;
  supportLayersData: any;
  featureLayer: any;
  myFeatureTable: any;    // currently reference several times but never initialized`12
  relationshipIds: any;
  resultAssetRelations: string[] = [];
  allFeatureLayers: any[] = [];
  faWindowClose = faWindowClose;
  faDownload = faDownload;
  faPlusCircle = faPlusCircle;

  format = "CSV";
  selind = 0;

  layersfields: any;
  gridApi;
  //gridColumnApi;
  paginationPageSize = 100;
  defaultColDef;
  columnDefs = [];
  rowData = [];
  rowSelectionMode = "single";
  columnsArray = [];
  dataArray = [];
  detailCellRendererParams;

  tabsFeatureTables = [];
  coinwallet;
  // selectedwallet;

  fieldAliases: any;

  selFeaturerowData = [];                 // copy of rows, for export
  columnDefsselFeature: any = [];
  selectedSetPlus: ILayerSelections[] = [];  // typical selected set (an object for each spatial layer with selected assets), plus one for each child layer with assets related to a selected spatial asset.
  public components;
  public selectedRowData: any;
  @Input() activeAsset: any;
  @Input() Graphic: any;
  public photosData = [];
  public linearAssetValues = false;
  public modalReference: NgbModalRef;
  public samples: any;
  public imageSrc: any;
  public PhotoDate;
  public SourceTag;
  public MeasureValue;
  public showDateByOrder = false;
  public showSequenceByOrder = false;
  public showSourceByOrder = false;
  public photoFl;
  public imgBase64: any;
  findUserAccessByRoleRegionLayerVar = false;
  columnsFieldsList;
  uploadfileName;

  selectedRows = [];
  //public docTypeDropdown: IDropdownListItem[] = [];

  private signLyrObj;
  private lightLyrObj;

  previousLayerIndex: number = 0;

  private highlightedOID: number = 0;   // grid rowindex is shifty, grab the object ID of the highlighted row
  private selsetLayerIndex: number = 0;     // for eeService.selectedSet
  private selsetFeatureIndex: number = 0;
  public activeTabIndex: number = -1;
  private activeRowIndex: number = -1;
  private parentTabIndex: number | null = null;
  private parentRowIndex: number | null = null;
  private childAssetId: string | null = null;
  private childTabActive: boolean = false;
  private newTab: boolean = false;
  private sub1;
  private sub2;
  private sub3;
  private sub4;
  private keepActiveAsset: boolean = false; // flag used to modify tabClick behavior to prevent automatic first row selection
  private fromChild: boolean = false; // flag to modify tabClick behavior indicating if the current action originated from a child asset
  private gridApis: any[] = []; // per tab, in same order, created as the tab is initialized

  //Added for ADA
  @HostListener("document:keydown.enter", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.target["type"] === "checkbox" && (event.target["id"].indexOf("fieldChk_") == 0 || event.target["id"].indexOf("taskchk") == 0)) {
      (<HTMLInputElement>event.target).click();
    } else if ((<HTMLInputElement>event.target).className === "ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-cell-value ag-cell-focus") {
      if ((<HTMLInputElement>event.target).getAttribute("col-id") === "Photo") {
        (<HTMLInputElement>event.target).click();
      }
    } else if (event.target["type"] === "button") {
      (<HTMLInputElement>event.target).click();
    }
  }

  constructor(
    private queryLayersService: QueryLayersService,
    private targetEl: ElementRef,
    private renderer: Renderer2,
    private objGlobals: Globals,
    private assetAttributesService: AssetAttributesService,
    public assetDetailService: AssetDetailService,
    private authenticationService: AuthenticationService,
    private genericLayerService: GenericLayerService,
    public eeService: EventEmittersService,
    public esritools: EsriMapComponent,
    private datePipe: DatePipe,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private imageCompressService: ImageCompressService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;

    // asset-table is displayed, upon user request, only when there is a selectedSet (created by querybuilder or select components).
    // The application automatically closes asset-table UI when selectedSet is cleared (including when beginning to creating a new one).
    // Therefore this component does not need to know when the selectedSet is updated.
    // Component needs to know when
    //    the active layer of the selected set changes (to update active tab)
    //    the active feature changes (to highlight the corresponding row in the asset table).
    // Layer and Feature updates can happen externally to the asset-table component, by
    //    map click on a selected feature
    //    Asset Viewer - by stepping though featuers of the active Layer, selecting a different Layer, or clicking an asset card.

    //Subscriptions
    this.sub1 = this.eeService.emitSelectedLayerIndexOnData.subscribe((index) => {  // layer activated
      this.selsetLayerIndex = index;
      if (this.activeChanged()) {
        this.keepActiveAsset = true;
        this.highlightActiveRow(this.selectedSetPlus[this.activeTabIndex].Data[this.activeRowIndex].attributes.AssetID);
      }
    });

    this.sub2 = this.eeService.emitSelectedParentIndexOnData.subscribe((index) => {  // asset activated
      this.selsetFeatureIndex = index;
      if (this.activeChanged()) {
        this.highlightActiveRow(this.selectedSetPlus[this.activeTabIndex].Data[this.activeRowIndex].attributes.AssetID);
      }
    });

    // this.sub3 = this.eeService.emitactiveAssetChangedBySelect.subscribe((result) => {  // active asset changed
    //   this.activeChanged();
    // });

    this.sub4 = this.eeService.emitSelectedChildAssetId.subscribe((childAssetId) => {
      if (this.childAssetId !== childAssetId) {
        this.childAssetId = childAssetId;
        this.activeChanged();
        if (this.childAssetId){
          this.highlightActiveRow(this.childAssetId);
        } else {
          this.fromChild = true;
        }
      }
    });

  }

  ngOnInit() {

    this.signLyrObj = new this.esritools.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds["signId"], { outFields: ["*"] })
    this.lightLyrObj = new this.esritools.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds["lightId"], { outFields: ["*"] })

    this.assetAttributesService.getFieldAlias().subscribe((results) => {
      this.fieldAliases = results;

      //force ParentID visibility for child assets
      this.fieldAliases.features.find(a => a.attributes.Field == "ParentID" && a.attributes.TableName == "Sign").attributes.GridVisible = true;
      this.fieldAliases.features.find(a => a.attributes.Field == "ParentID" && a.attributes.TableName == "Light").attributes.GridVisible = true;

      this.collectDataForTabs().then( () => {  // build out selectedSetPlus data for tabs.  note: as of now, this is a one time activity and data does not update if one of the selected assets is retired or replaced.

        // punt - open table on first row of first tab. could not get the gridApi correct when trying to open to whatever asset was active when user requested asset table.
        // this.activeTabIndex = 0; 
        // this.activeRowIndex = 0;
        const selectedFLName = this.eeService.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.name;
        this.activeTabIndex = this.selectedSetPlus.findIndex(layer => layer.LayerInfo.name === selectedFLName);
        this.activeRowIndex = this.eeService.selectedFeatureIndex;

        this.loadActiveAssetClassTable();
        this.keepActiveAsset = true;
        //this.newTab = false; 
      });  

    });

    //ADA fix
    document.getElementById("closeAssetTable")?.focus();
  }

  onGridReady(event): void {
    this.gridApis.push(event.api);
  }

  ngOnDestroy() {
    if (this.myFeatureTable) {
      this.myFeatureTable.destroy();
    }
    this.sub1?.unsubscribe();
    this.sub2?.unsubscribe();
    this.sub3?.unsubscribe();
    this.sub4?.unsubscribe();
    this.gridApi = null;
  }

  activeChanged(): boolean{

    const selectedFLName = this.eeService.selectedSet[this.eeService.selectedLayerIndex].LayerInfo.name;
    let selectedAssetId: string;
    try {
      selectedAssetId = this.eeService.selectedSet[this.eeService.selectedLayerIndex].Data[this.eeService.selectedFeatureIndex].attributes.AssetID;
    } catch (error) {
      // if update to layerIndex is emitted prior to featureIndex, featureIndex may be out of bounds for the new layer's Data array. default to first row.
      selectedAssetId = this.eeService.selectedSet[this.eeService.selectedLayerIndex].Data[0].attributes.AssetID;
    }
    let newTab: boolean = false;
    let newRow: boolean = false;

    let newChild = this.childAssetId != this.eeService.selectedChildAssetId;
    if (newChild) {
      this.childAssetId = this.eeService.selectedChildAssetId;
    }

    if (selectedFLName === "Support" && this.childAssetId) {
      this.parentTabIndex = this.selectedSetPlus.findIndex(layer => layer.LayerInfo.name === "Support");
      this.childTabActive = true;
      const childType = this.childAssetId.includes("SIG") ? "Sign" : this.childAssetId.includes("LGT") ? "Light" : "";
      newTab = this.activeTabIndex != this.selectedSetPlus.findIndex(layer => layer.LayerInfo.name === childType);
      if (newTab){
        this.activeTabIndex = this.selectedSetPlus.findIndex(layer => layer.LayerInfo.name === childType);
        //this.newTab = true;
      }
      newRow = this.activeRowIndex != this.selectedSetPlus[this.activeTabIndex].Data.findIndex(row => row.attributes.AssetId === this.childAssetId);
      if (newRow){
        this.activeRowIndex = this.selectedSetPlus[this.activeTabIndex].Data.findIndex(row => row.attributes.AssetID === this.childAssetId);
        this.parentRowIndex = this.selectedSetPlus[this.parentTabIndex].Data.findIndex(row => row.attributes.AssetID === selectedAssetId);
      }
    } else {
      this.childTabActive = false;
      newTab = this.activeTabIndex != this.selectedSetPlus.findIndex(layer => layer.LayerInfo.name === selectedFLName)
      if (newTab){
        this.activeTabIndex = this.selectedSetPlus.findIndex(layer => layer.LayerInfo.name === selectedFLName);
        //this.newTab = true;
      }
      newRow = this.activeRowIndex != this.selectedSetPlus[this.activeTabIndex].Data.findIndex(row => row.attributes.AssetID === selectedAssetId)
      if (newRow){
        this.activeRowIndex = this.selectedSetPlus[this.activeTabIndex].Data.findIndex(row => row.attributes.AssetID === selectedAssetId);
      }
      this.parentTabIndex = null;
      this.parentRowIndex = null;
    }

    return newTab || newRow || newChild;
  }

  collectDataForTabs() {
    // populate selectedSetPlus
    
    const tempSelSetPlus: ILayerSelections[] = []; // don't want to set selectedSetPlus directly until fully populated
    // add spatial layers (excluding visualization layers) from selectedSet
    tempSelSetPlus.push(...this.eeService.selectedSet.filter( (f) => f.LayerInfo.type !== "visualization"));
    
    // add child layers that contain assets related to selectedSet
    let supports = tempSelSetPlus.find( f => f.LayerInfo.name === "Support" );
    // if (!supports) {
    //   this.selectedSetPlus = tempSelSetPlus;
    // } else {
    const signIds:string[] = [];
    const lightIds:string[] = [];
    const supportIndex = tempSelSetPlus.indexOf(supports);
    const fsUrl = this.currentUser.webServiceURL + environment.featureServer;
    const query = new this.esritools.Query( { returnGeometry: false });
    query.outFields = ["*"];  // setting in the initalizer isn't working
    let childQueries = [];
    let childLayerInfo: ILayer[] = [];

    // iterate selected supports and collect any child asset IDs. See generic-map-methods.service's getOpenTasks method for reference.
    supports?.Data.forEach( (f) => {
        f.attributes.opentasksobj?.Sign?.forEach( (s) => signIds.push(s.AssetId) );
        f.attributes.opentasksobj?.Light?.forEach( (l) => lightIds.push(l.AssetId) );
    });

    // query for child asset records
    if (signIds.length > 0) {
      query.where = "AssetID IN ('" + signIds.join("','") + "')";
      childQueries.push( new this.esritools.QueryTask(fsUrl + this.currentUser.tableIds.signId).execute(query) );
      childLayerInfo.push( {layerId: this.currentUser.tableIds.signId, name: "Sign", lyrObj: this.signLyrObj} as ILayer);
    };
    if (lightIds.length > 0){
      query.where = "AssetID IN ('" + lightIds.join("','") + "')";
      childQueries.push ( new this.esritools.QueryTask(fsUrl + this.currentUser.tableIds.lightId).execute(query) );
      childLayerInfo.push( {layerId: this.currentUser.tableIds.lightId, name: "Light", lyrObj: this.lightLyrObj} as ILayer) ;
    };

    return new Promise( (resolve) => {
      if (childQueries.length === 0) {
        this.selectedSetPlus = tempSelSetPlus;
        resolve(true);
      } else {
      // process child queries
        this.esritools.all(childQueries).then( (results) => {
          results.forEach( (r, i) => {

            const lyrInfo = childLayerInfo[i];
            r.features.forEach( (f) => {
              f["_layer"] = lyrInfo.lyrObj;
            });

            const userLayer = this.eeService.userLayers.find( (ac) => ac.layerId === childLayerInfo[i].layerId );
            // this.selectedSetPlus.splice(supportIndex + 1, 0, {
            //   Data: r.features,
            //   LayerInfo: { layerId: lyrInfo.layerId, name: lyrInfo.name, alias: userLayer?.alias, aliasSL: userLayer?.aliasSL, accessPrivilege: userLayer!.accessPrivilege } as ILayer
            // });
            tempSelSetPlus.push({
              Data: r.features,
              LayerInfo: { layerId: lyrInfo.layerId, name: lyrInfo.name, alias: userLayer?.alias, aliasSL: userLayer?.aliasSL, accessPrivilege: userLayer!.accessPrivilege } as ILayer
            });
          });
          this.selectedSetPlus = tempSelSetPlus;
          resolve(true);
        });
      }
    });

  }

  loadActiveAssetClassTable() {
    const tabName = this.selectedSetPlus[this.activeTabIndex].LayerInfo.name.toLowerCase();
    const columns = this.fieldAliases.features.filter(
      (feature) =>
        //Jira Id-933
        feature.attributes.TableName.toLowerCase() === tabName
    );
    this.columnsFieldsList = columns;
    this.columnDefsselFeature = [];
    this.columnDefsselFeature.push({
      field: "Photo",
      tooltipField: "Photo",
      width: 80,
      cellRenderer: (params) => {
        return `<img class="table-image-icon" alt="Image" src="assets/images/icon_image.svg">`;
      }
    });
    columns.forEach((element) => {
      if (element.attributes.Field == "DoNotReplace") {
        this.columnDefsselFeature.push({
          field: "DoNotReplaceDomainValue",
          headerName: this.currentUser.scndLang ? element.attributes.FieldAlias_SL : element.attributes.FieldAlias
        });
      } else if (element.attributes.GridVisible) {
        this.columnDefsselFeature.push({
          field: element.attributes.Field,
          headerName: this.currentUser.scndLang ? element.attributes.FieldAlias_SL : element.attributes.FieldAlias
        });
      }
    });
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
      tooltipComponent: "customTooltip"
    };
    this.components = { customTooltip: CustomTooltip };
    this.selFeaturerowData = [];
    this.selectedSetPlus[this.activeTabIndex].Data.forEach((feature) => {
      feature.attributes["Photo"] = "Photo";
      //TSDRSAM-2594
      feature.attributes.InstallDate = feature.attributes.InstallDate ? this.datePipe.transform(feature.attributes.InstallDate, "MM/dd/yyyy hh:mm a") : null;
      feature.attributes.RetireDate = feature.attributes.RetireDate ? this.datePipe.transform(feature.attributes.RetireDate, "MM/dd/yyyy hh:mm a") : null;
      feature.attributes.LastModifyDate = feature.attributes.LastModifyDate ? this.datePipe.transform(feature.attributes.LastModifyDate, "MM/dd/yyyy hh:mm a") : null;
      feature.attributes.CollectDate = feature.attributes.CollectDate ? this.datePipe.transform(feature.attributes.CollectDate, "MM/dd/yyyy hh:mm a") : null;
      //  Added by Sowjanya Jira Id:-32 on 10/11/2021
      // feature.attributes.DoNotReplace=  0 ? 'No':'Yes'
      if (feature._layer && feature._layer._fields && feature._layer._fields.length > 0) {
        // TSDRSAM-1090 By Manikantha V -->
        if (feature._layer._fields.filter((item) => item.name == "DoNotReplace")[0].domain.codedValues.filter((item) => item.code == feature.attributes.DoNotReplace)[0]) {
          feature.attributes["DoNotReplaceDomainValue"] = feature._layer._fields.filter((item) => item.name == "DoNotReplace")[0].domain.codedValues.filter((item) => item.code == feature.attributes.DoNotReplace)[0].name;
        }
      } else {
        feature.attributes["DoNotReplaceDomainValue"] = feature.attributes.DoNotReplace;
      }
      this.selFeaturerowData.push(feature.attributes);
    });
    //this.gridColumnApi = undefined;
  }

  onRowDataUpdated(event) {  // fires when table data is updated (load tab table data, change column visibilty)
    // if (this.childTabActive){
    //   this.gridApi = event.api;
    // } else {
    //   this.gridApi = this.gridApis[this.activeTabIndex];
    // }
    this.highlightActiveRow(this.selectedSetPlus[this.activeTabIndex].Data[this.activeRowIndex].attributes.AssetID);
  }

  // TSDRSAM-1090 By Manikantha V -->
  highlightActiveRow(assetId) {
    this.gridApi = this.gridApis[this.activeTabIndex];
    if (!this.gridApi) {
      console.warn("Grid API is not available.");
    }  else {                           
      if(this.childTabActive) {
        if ( !(assetId.includes("SIG") || assetId.includes("LGT")) ) {
          if (this.childAssetId) {
            assetId = this.childAssetId
          } else {
            assetId = this.selectedSetPlus[this.activeTabIndex].Data.find((item) => item.attributes.ParentID == assetId)?.attributes.AssetID;
          }
        }
      } 
      this.gridApi.forEachNode( (node) => {
        if (node.data.AssetID === assetId) {
          if (node.selected === false) {
            node.setSelected(true);
            this.gridApi.ensureIndexVisible(node.rowIndex, "middle");
          }
        }
      });
    }
  }

  onCellClicked(evt, content): void { // if photo cell was clicked, open photo viewer
    if (evt && evt.value == "Photo") {
      setTimeout(() => {
        if (this.selectedSetPlus[this.activeTabIndex].LayerInfo.name == "Sign" || this.selectedSetPlus[this.activeTabIndex].LayerInfo.name == "Light") {
          this.viewImage(content, true);
        } else {
          this.viewImage(content, false);
        }
      }, 1000);
    }
  }

  onRowClick(evt): void {
    // can't rely on alignment between evt.rowIndex and activeRowIndex due to sorting, filtering, or other grid operations
    if (this.selectedSetPlus[this.activeTabIndex].Data[this.activeRowIndex].attributes.OBJECTID != evt.node.data.OBJECTID) {
      this.activeRowIndex = this.selectedSetPlus[this.activeTabIndex].Data.findIndex(item => {
        return item.attributes.OBJECTID == evt.node.data.OBJECTID;}
      );
      if (this.childTabActive) {
        this.eeService.setSelectedChildAsset(evt.node.data.AssetID);
        this.parentRowIndex = this.selectedSetPlus[this.parentTabIndex!].Data.findIndex( item => 
          { return item.attributes.AssetID === evt.data.ParentID; } 
        );
        this.eeService.setSelectedFeatureIndex(this.parentRowIndex);
      } else {
        this.eeService.setSelectedFeatureIndex(this.activeRowIndex);
      }
    }
  }

  onTabClick(event: MatTabChangeEvent) {
    // fires when component first opened and when active asset class changed due to tab click, map select or av update

    const tabName = this.selectedSetPlus[event.index].LayerInfo.name;
    this.childTabActive = (["Sign", "Light"].includes(tabName));

    if (tabName === "Support" && this.fromChild) {
      // when switching to the Support tab - from a Child tab - prevent automatic first row selection
      this.keepActiveAsset = true;
    }
    this.fromChild = false;

    if (this.childTabActive) {
      if (this.childAssetId && ( (this.childAssetId.includes("SIG") && tabName === "Sign") || this.childAssetId.includes("LGT") && tabName === "Light" )){  // not switching between child tabs
        this.activeRowIndex = this.selectedSetPlus[event.index].Data.findIndex(row => row.attributes.AssetID === this.childAssetId);
      } else {
        this.activeRowIndex = 0;   // note: first in source data, disregarding grid sort/filter
        this.childAssetId = this.selectedSetPlus[event.index].Data[this.activeRowIndex].attributes.AssetID;
      }
      if (this.eeService.selectedChildAssetId !== this.childAssetId){
        this.eeService.setSelectedChildAsset(this.childAssetId);
      }
      this.selsetLayerIndex = this.eeService.selectedSet.findIndex(lyr => lyr.LayerInfo.name === "Support");  //need this?
      this.parentTabIndex = this.selectedSetPlus.findIndex(lyr => lyr.LayerInfo.name === "Support");
      this.parentRowIndex = this.selectedSetPlus[this.parentTabIndex].Data.findIndex(row => { 
        return row.attributes.AssetID === this.selectedSetPlus[this.activeTabIndex].Data[this.activeRowIndex].attributes.ParentID;
      });
      if ( this.eeService.selectedLayerIndex !== this.selsetLayerIndex || this.eeService.selectedFeatureIndex !== this.parentRowIndex) {
        this.eeService.setSelectedLayerIndex(this.selsetLayerIndex, this.parentRowIndex);
      }
      
    } else {
      this.childAssetId = null;
      this.eeService.setSelectedChildAsset(null);
      this.parentTabIndex = null;
      this.parentRowIndex = null; 

      this.selsetLayerIndex = this.eeService.selectedSet.findIndex(lyr => lyr.LayerInfo.name === tabName);
      if (this.keepActiveAsset) {
        // when component is first opened, modify tabClick behavior to prevent automatic first row selection, to select row associated with active asset on map/av
        this.keepActiveAsset = false;
      } else {
        if ( this.eeService.selectedLayerIndex !== this.selsetLayerIndex || this.eeService.selectedFeatureIndex !== 0) {
          this.eeService.setSelectedLayerIndex(this.selsetLayerIndex, 0);   // note: first in source data, disregarding grid sort/filter
        }
      }


    }

    this.loadActiveAssetClassTable();
  }


  // Header
  closeGrid() {
    //add call to toggle asset viewer size.
    if (this.myFeatureTable) {
      this.myFeatureTable.destroy();
    }
    this.eeService.setAssetTable(false);
  }
  getCloseIcon() {
    return "cross";
  }
  getAddIcon() {
    return "plus";
  }
  getDownloadIcon() {
    return "download";
  }
  toggleColumnVisibility(event) {
    const value = event.event.target.checked ? 1 : 0;
    this.fieldAliases.features.find( (f) =>
        f.attributes.TableName === this.selectedSetPlus[this.activeTabIndex].LayerInfo.name &&
        f.attributes.Field == event.columnfield.attributes.Field
    ).attributes.GridVisible = value;
    this.loadActiveAssetClassTable();
  }
  onFormatChange(event) {
    this.format = event;
    console.log(event);
  }


  // Export  - Added by Abhilash Jira Id:-39 on 9/28/2021
  customExportCSV(format) {
    const data: any[][] = this.selFeaturerowData;
   if (data == null || !data.length) {
      return null;
    }
    let csv;
    const tablebody = [];
    const tableheader = [];
    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const columns = [];
    this.columnDefsselFeature.forEach((element) => {
      // if (!element.hidden) {
      if (element.field != "Photo") {
        columns.push(element.field);
      }
      // }
    });
    const arr = columns.map((item) => ({ key: item, value: "" }));
    const columnkeys = arr.reduce(function (map, obj) {
      map[obj.key] = obj.value;
      return map;
    }, {});
    const keys = Object.keys(columnkeys);
    let result = "";
    //TSDRSAM-2569 fixes
    let columnLength = keys.length;
    if (format === "PDF") {
      columnLength = 15
    }

    keys.forEach((key, i) => {
      if (i < columnLength) {
        tableheader.push({ text: key, style: "tableHeader" });
      }
    });
    tablebody.push(tableheader);
    result += tableheader.map(x=>x.text).join(columnDelimiter);
    result += lineDelimiter;
    let ctr = 0;

    // const selfeatures =
    //   this.eeService.selectedSet[
    //     this.eeService.selectedLayerIndexOnData
    //   ].LayerInfo.lyrObj.getSelectedFeatures();
    const selfeatures = data;
    selfeatures.forEach((element) => {
      const tablerow = [];

      if (element) {
        keys.forEach(function (key, i) {
          if (i < columnLength) {
            result += element[key];
            tablerow.push(element[key] == undefined ? "" : element[key]);
            result += columnDelimiter;
          }
        });
        ctr++;
        tablebody.push(tablerow);
        result += lineDelimiter;
      }
    });

    if (ctr === selfeatures.length && format === "CSV") {
      csv = result;

      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }

      const encodedUri = encodeURI(csv);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      const filename = this.selectedSetPlus[this.activeTabIndex].LayerInfo.name + ".csv";
      link.setAttribute("download", filename);
      link.click();
    }

    if (ctr === selfeatures.length && format === "PDF") {
      const dd = {
        pageSize: "A4",
        pageOrientation: "landscape",
        fontSize: 8,
        widths: "auto",
        content: [
          {
            style: "tableExample",
            table: {
              body: tablebody
            },
            pageOrientation: "portrait",
            layout: {
              fillColor(rowIndex, node, columnIndex) {
                return rowIndex % 2 === 0 ? "#CCCCCC" : null;
              }
            }
          }
        ],
        styles: {
          header: {
            fontSize: 9,
            bold: true,
            margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 8,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15],
            fontSize: 8
          },
          tableHeader: {
            bold: true,
            fontSize: 9,
            color: "black"
          }
        }
      };
      Swal.fire("Only first 15 attributes will be downloaded in the PDF format.");
      pdfMake.createPdf(dd).download(
        // this.eeService.selectedSet[this.eeService.selectedLayerIndexOnData].LayerInfo.layerName + ".pdf"
        this.selectedSetPlus[this.activeTabIndex].LayerInfo.name + ".pdf"
      );
    }
  }
  exportExcel() {
    this.customExportCSV(this.format);
  }


  // Photo Viewer -- second implementation. TODO reuse single component
  // Added by Abhilash Jira Id:-40 on 9/28/2021 Start
  viewImage(content, childFlag) {
    this.photosData = [];
    this.imageSrc = "";
    this.PhotoDate = "";
    this.SourceTag = "";
    this.MeasureValue = "";
    this.imgBase64 = "";
    this.samples = [];
    if (childFlag) {
      this.activeAsset = "";
    } else {
      this.activeAsset = this.eeService.activeAssetInfo;
    }
    this.findUserAccessByRoleRegionLayer();
    this.photoFl = new this.esritools.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.documentId);
    if (childFlag) {
      this.activeAsset = "";
      this.linearAssetValues = false;
    } else if (this.activeAsset[2].geometry !== undefined && this.activeAsset[2].geometry.type === "polyline") {
      this.linearAssetValues = true;
    } else {
      this.linearAssetValues = false;
    }
    let assetId;
    if (childFlag) {
      assetId = this.selectedRowData[0].AssetID;
    } else if (this.activeAsset[0].AssetID) {
      assetId = this.activeAsset[0].AssetID;
    } else {
      assetId = this.activeAsset[0].signAttribute.AssetID;   //TODO*** remove all references to .signAttribute - don't think it is ever defined
    }
    this.genericLayerService.getFilteredFeaturesByField(this.currentUser.tableIds.documentId, "AssetID", assetId).subscribe((results: any) => {
      results.features.forEach((data) => {
        this.photosData.push(data);
      });
      this.imageGenerate();
    });
    this.modalReference = this.modalService.open(content, {
      centered: true,
      windowClass: "asset-photo",
      size: "xl"
    });
  }
  cancel() {
    this.modalReference.close();
  }
  imageGenerate(data?) {
    this.samples = [];
    const photoData = data ? data : this.photosData;
    let contentType;
    if (photoData.length > 0) {
      photoData.forEach((photo) => {
        //70
        this.assetDetailService.getImageAsBase64(photo.attributes.OBJECTID, this.currentUser.clientId, photo.attributes.DocType).subscribe(
          (base64Image: any) => {
            if (photo.attributes.DocType.toLowerCase() == "pdf") {
              contentType = "application/pdf";
            } else {
              contentType = "image/png";
            }
            this.samples.push({
              label: photo.attributes.Filename,
              imgBase64: base64Image,
              url: `data:${contentType};base64, ${base64Image}`,
              attributes: photo.attributes,
              Date: photo.attributes.DocDate,
              SourceTag: photo.attributes.SourceTag,
              Measure: photo.attributes.Asset_Segment_Measure
            });
            this.DescendingOrder("Date");
          },
          (err) => {
            if (err.message && err.message == "File Not Found") {
              this.samples.push({
                label: photo.attributes.Filename,
                url: "",
                imgBase64: "",
                attributes: photo.attributes,
                Date: photo.attributes.DocDate,
                SourceTag: photo.attributes.SourceTag,
                Measure: photo.attributes.Asset_Segment_Measure
              });
              this.DescendingOrder("Date");
            }
          }
        );
      });
    }
  }
  DescendingOrder(sortKey) {
    this.samples.sort((a, b) => {
      const x = a[sortKey];
      const y = b[sortKey];
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    });
    if (this.samples.length > 0) {
      this.imageSrc = this.samples[0].url;
      this.PhotoDate = this.samples[0].Date;
      this.SourceTag = this.samples[0].SourceTag;
      this.MeasureValue = this.samples[0].Measure;
      this.imgBase64 = this.samples[0].imgBase64;
    } else {
      this.imageSrc = "";
      this.PhotoDate = "";
      this.SourceTag = "";
      this.MeasureValue = "";
      this.imgBase64 = "";
    }
  }
  AscendingOrder(sortKey) {
    this.samples.sort((a, b) => {
      const x = a[sortKey];
      const y = b[sortKey];
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });
    if (this.samples.length > 0) {
      this.imageSrc = this.samples[0].url;
      this.PhotoDate = this.samples[0].Date;
      this.SourceTag = this.samples[0].SourceTag;
      this.MeasureValue = this.samples[0].Measure;
      this.imgBase64 = this.samples[0].imgBase64;
    } else {
      this.imageSrc = "";
      this.PhotoDate = "";
      this.SourceTag = "";
      this.MeasureValue = "";
      this.imgBase64 = "";
    }
  }
  OrderImages(sortKey) {
    if (sortKey === "Date") {
      if (this.showDateByOrder) {
        this.showDateByOrder = !this.showDateByOrder;
        this.DescendingOrder(sortKey);
      } else {
        this.showDateByOrder = !this.showDateByOrder;
        this.AscendingOrder(sortKey);
      }
    } else if (sortKey === "Measure") {
      if (this.showSequenceByOrder) {
        this.showSequenceByOrder = !this.showSequenceByOrder;
        this.DescendingOrder(sortKey);
      } else {
        this.showSequenceByOrder = !this.showSequenceByOrder;
        this.AscendingOrder(sortKey);
      }
    } else if (sortKey === "SourceTag") {
      if (this.showSourceByOrder) {
        this.showSourceByOrder = !this.showSourceByOrder;
        this.DescendingOrder(sortKey);
      } else {
        this.showSourceByOrder = !this.showSourceByOrder;
        this.AscendingOrder(sortKey);
      }
    }
  }
  EventChange(event) {
    this.imageSrc = event.value;
    this.samples.forEach((imageData) => {
      if (imageData.url === event.value) {
        this.PhotoDate = imageData.Date;
        this.SourceTag = imageData.SourceTag;
        this.MeasureValue = imageData.Measure;
        this.imgBase64 = imageData.imgBase64;
      }
    });
  }
  findUserAccessByRoleRegionLayer() {
    let layerinfo;
    // Region
    if (this.currentUser.selectedRegion?.accessPrivilege === "Data Editor") {
      if (this.activeAsset && this.activeAsset.length > 0) {
        layerinfo = this.currentUser.assignedAssetClasses!.find( (layer) => {
          return layer.layerId === this.activeAsset[1].layerId;
        });
      } else {
        layerinfo = this.currentUser.assignedAssetClasses!.find( (layer) => {
          return layer.layerId === this.currentUser.tableIds.signId || layer.layerId === this.currentUser.tableIds.lightId;
        });
      }
      // Layer
      if (layerinfo && layerinfo.accessPrivilege === "Data Editor") {
        this.findUserAccessByRoleRegionLayerVar = true;
      } else {
        this.findUserAccessByRoleRegionLayerVar = false;
      }
    } else {
      this.findUserAccessByRoleRegionLayerVar = false;
    }
  }
  export() {
    if (this.imgBase64 !== undefined && this.imgBase64 !== "") {
      var selectedFile = { fileBase64: this.imageSrc };
      var mimeType = getMimeType(selectedFile.fileBase64);
      if (mimeType.toLowerCase() == "pdf") {
        var pdfWindow = window.open("");
        pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(this.imgBase64) + "'></iframe>");
      } else {
        var image = new Image();
        image.src = "data:image/" + mimeType + ";base64," + this.imgBase64;
        var w = window.open("_blank");
        w.document.write(image.outerHTML);
      }
    } else {
      Swal.fire(this.translateService.instant("Select.alertassessment.nodocument"));
    }
  }
  setThis() {
    return this;
  }
  uploadNew(files) {
    if (files.length > 0) {
      const fileElement = environment.DocumentSupportFormats.includes(files[0].name.split(".")[files[0].name.split(".").length - 1].toLowerCase());
      if (!fileElement) {
        Swal.fire(this.translateService.instant("Select.file.unsupportedformat"));
        const input: any = document.querySelector("input[type=file]");
        input.value = null;
        return;
      }
      const _this = this.setThis();
      const doctyp = files[0].name.split(".")[1].toUpperCase();

      const photoAsset = new this.esritools.Graphic();
      const attr: any = [];
      attr.AssetID = this.selectedRowData[0].AssetID;
      attr.SourceTag = "General";
      attr.DocType = doctyp;
      attr.DocID = this.selectedRowData[0].OBJECTID;
      attr.Filename = files[0].name;
      attr.DocDate = new Date(Date.now()).getTime();
      attr.ModifiedBy = this.currentUser.username;
      attr.LastModifyDate = new Date(Date.now()).getTime();
      photoAsset.setAttributes(attr);

      const photoFl = new this.esritools.FeatureLayer(this.currentUser.webServiceURL + environment.featureServer + this.currentUser.tableIds.documentId);

      photoFl.applyEdits(
        [photoAsset],
        null,
        null,
        (res) => {
          if (res[0].success) {
            _this.assetDetailService.UpdateDocId(_this.esritools.Graphic, res[0].objectId, photoFl);
            this.uploadfileName = files[0].name;
            const options = new ResizeOptions();
            // eslint-disable-next-line camelcase
            options.Resize_Max_Height = 1280;
            // eslint-disable-next-line camelcase
            options.Resize_Max_Width = 1280;
            // eslint-disable-next-line camelcase
            options.Resize_Quality = 80;
            // eslint-disable-next-line camelcase
            options.Resize_Type = "image/jpg";

            const reader = new FileReader();
            let fileInBase64Data;
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
              fileInBase64Data = reader.result;
            };

            if (files[0].name.split(".")[1].toUpperCase() == "PDF") {
              _this.assetDetailService.uploadImage(files[0], res[0].objectId, this.currentUser.clientId).subscribe(
                (uploadres: any) => {
                  if (uploadres.message === "Photo Saved Successfully") {
                    Swal.fire(this.translateService.instant("Select.alertassessment.fileuploadsuccess"));
                    photoAsset.attributes.OBJECTID = res[0].objectId;
                    this.samples.push({
                      label: photoAsset.attributes.Filename,
                      imgBase64: fileInBase64Data.split(",")[1],
                      url: `data:application/pdf;base64, ${fileInBase64Data.split(",")[1]}`,
                      attributes: photoAsset.attributes,
                      Date: photoAsset.attributes.DocDate,
                      SourceTag: photoAsset.attributes.SourceTag,
                      Measure: photoAsset.attributes.Asset_Segment_Measure
                    });
                    if (this.samples.length > 0) {
                      this.imageSrc = this.samples[0].url;
                      this.PhotoDate = this.samples[0].Date;
                      this.SourceTag = this.samples[0].sourceTag;
                      this.MeasureValue = this.samples[0].Measure;
                      this.imgBase64 = this.samples[0].imgBase64;
                    } else {
                      this.imageSrc = "";
                      this.PhotoDate = "";
                      this.SourceTag = "";
                      this.MeasureValue = "";
                      this.imgBase64 = "";
                    }
                    this.DescendingOrder("Date");
                  }
                },
                (err) => {
                  if (err.error.message === "File Format/Size is Not Correct") {
                    const featurese = [];
                    const features = new this.esritools.Graphic();
                    const assetAttr: any = [];
                    assetAttr.OBJECTID = res[0].objectId;
                    features.setAttributes(assetAttr);
                    featurese.push(features);
                    photoFl
                      .applyEdits(null, null, featurese)
                      .then(
                        function () {
                          Swal.fire(this.translateService.instant("Select.alertassessment.filelimit"));
                        }.bind(this)
                      )
                      .catch(function (error) {
                        console.log("===============================================");
                        console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                        console.log("error = ", error);
                      });
                  } else {
                    console.log(err.error.message);
                  }
                }
              );
            } else {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              const newFileDataC = _this.compressImage(files[0], options).then((newFileDataC: any) => {
                _this.assetDetailService.uploadImage(newFileDataC, res[0].objectId, this.currentUser.clientId).subscribe(
                  (uploadres: any) => {
                    if (uploadres.message === "Photo Saved Successfully") {
                      Swal.fire(this.translateService.instant("Select.alertassessment.fileuploadsuccess"));
                      photoAsset.attributes.OBJECTID = res[0].objectId;
                      this.samples.push({
                        label: photoAsset.attributes.Filename,
                        imgBase64: fileInBase64Data.split(",")[1],
                        url: `data:image/png;base64, ${fileInBase64Data.split(",")[1]}`,
                        attributes: photoAsset.attributes,
                        Date: photoAsset.attributes.DocDate,
                        SourceTag: photoAsset.attributes.SourceTag,
                        Measure: photoAsset.attributes.Asset_Segment_Measure
                      });
                      if (this.samples.length > 0) {
                        this.imageSrc = this.samples[0].url;
                        this.PhotoDate = this.samples[0].Date;
                        this.SourceTag = this.samples[0].sourceTag;
                        this.MeasureValue = this.samples[0].Measure;
                        this.imgBase64 = this.samples[0].imgBase64;
                      } else {
                        this.imageSrc = "";
                        this.PhotoDate = "";
                        this.SourceTag = "";
                        this.MeasureValue = "";
                        this.imgBase64 = "";
                      }
                      this.DescendingOrder("Date");
                    }
                  },
                  (err) => {
                    if (err.error.message === "File Format/Size is Not Correct") {
                      const featurese = [];
                      const features = new this.esritools.Graphic();
                      const assetAttr: any = [];
                      assetAttr.OBJECTID = res[0].objectId;
                      features.setAttributes(assetAttr);
                      featurese.push(features);
                      photoFl
                        .applyEdits(null, null, featurese)
                        .then(
                          function () {
                            Swal.fire(this.translateService.instant("Select.alertassessment.filelimit"));
                          }.bind(this)
                        )
                        .catch(function (error) {
                          console.log("===============================================");
                          console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                          console.log("error = ", error);
                        });
                    } else {
                      console.log(err.error.message);
                    }
                  }
                );
              });
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  async compressImage(fileData, options) {
    const result = await this.compressImageAndUpload(fileData, options);
    return result;
  }
  compressImageAndUpload(fileData, options) {
    return new Promise((resolve) => {
      const files: any = [fileData];
      const images = [];
      let newfileData;
      // let images: Array<IImage> = [];
      this.imageCompressService.compressImageArray(files, options).subscribe(
        (image) => {
          images.push(image);
        },
        (error) => {
          console.log("Error while converting");
        },
        () => {
          let processedImages = images;
          console.log();
          newfileData = this.dataURItoBlob(processedImages[0].compressedImage.imageDataUrl);
          resolve(newfileData);
        }
      );
      // this.imageCompressService.compressImageArray(files, options).then(
      //   function (observableImages) {
      //     observableImages.subscribe(
      //       (image) => {
      //         images.push(image);
      //       },
      //       (error) => {
      //         console.log("Error while converting");
      //       },
      //       () => {
      //         this.processedImages = images;
      //         console.log();
      //         newfileData = this.dataURItoBlob(this.processedImages[0].compressedImage.imageDataUrl);
      //         resolve(newfileData);
      //       }
      //     );
    });
  }
  dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    // return new Blob([ab], { type: 'image/jpeg' });
    return new File([ia], this.uploadfileName, { type: "image/jpeg" });
  }
  dataURItoBlobTest(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);
    // separate out the mime component
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
  }
  deleteImage() {
    Swal.fire({
      title: environment.deleteMessage,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.translateService.instant("Select.alertassessment.delete")
    }).then((result) => {
      if (result.value) {
        this.samples.forEach((data, key) => {
          if (data.url === this.imageSrc) {
            const featurese = [];
            const features = new this.esritools.Graphic();
            features.setAttributes(data.attributes);
            featurese.push(features);
            this.photoFl
              .applyEdits(null, null, featurese)
              .then(
                function () {
                  Swal.fire(this.translateService.instant("Select.alertcarddisplay.deletedsucceffully"));
                  this.samples.splice(key, 1);
                  if (this.samples.length > 0) {
                    this.imageSrc = this.samples[0].url;
                    this.PhotoDate = this.samples[0].Date;
                    this.SourceTag = this.samples[0].SourceTag;
                    this.MeasureValue = this.samples[0].Measure;
                    this.imgBase64 = this.samples[0].imgBase64;
                  } else {
                    this.imageSrc = "";
                    this.PhotoDate = "";
                    this.SourceTag = "";
                    this.MeasureValue = "";
                    this.imgBase64 = "";
                  }
                }.bind(this)
              )
              .catch(function (error) {
                console.log("===============================================");
                console.error("[ applyEdits ] FAILURE: ", error.code, error.name, error.message);
                console.log("error = ", error);
              });
          }
        });
      }
    });
  }
  // Added by Abhilash Jira Id:-40 on 9/28/2021 End
}
